import {inject, Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import {AuthService} from "../services/auth/auth.service";
import {Observable, tap} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
    private static DEFAULT_PERMISSION: string = "Permission.Watcher.Access";

    private authService: AuthService = inject(AuthService);
    private router: Router = inject(Router);

    constructor() {}

    canActivate(): Observable<boolean> {
        return this.authService.hasPermission(PermissionGuard.DEFAULT_PERMISSION).pipe(
            tap(hasPermission => {
                if (!hasPermission) {
                    this.router.navigate(['/unauthorized']);
                }
            })
        );
    }
}
